import { RiskAssessmentResultControlType } from '@risksmart-app/domain/src/types/consts/risk-assessment-result-control-type';
import type { UpdateUncontrolledRiskInternalAuditResultMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { UpdateUncontrolledRiskInternalAuditResultDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

import type { UpdateRiskInternalAuditResultInput } from './useUpdateControlledRiskInternalAuditResult';

export const useUpdateUncontrolledRiskInternalAuditResult = createMutationHook({
  name: 'updateUncontrolledRiskInternalAuditResult',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.internalAuditResult.updateRisk.mutationOptions({
      onSuccess,
    }),
  mapInput: (input: UpdateRiskInternalAuditResultInput) => ({
    ...input,
    ControlType: RiskAssessmentResultControlType.Uncontrolled,
  }),
  mapResponse: (): UpdateUncontrolledRiskInternalAuditResultMutation => ({
    update_risk_uncontrolled_internal_audit_result: {
      __typename: 'risk_uncontrolled_internal_audit_result_mutation_response',
      affected_rows: 1,
    },
  }),
  invalidate: (trpc) => [
    trpc.frontend.internalAuditResult.pathKey(),
    trpc.frontend.assessment.internalAuditResultCount.queryKey(),
    // COI-471 parity: Apollo twin also evicts `internal_audit_report`.
    trpc.frontend.internalAuditReport.pathKey(),
  ],
  graphqlDocument: UpdateUncontrolledRiskInternalAuditResultDocument,
  graphqlVariables: (input: UpdateRiskInternalAuditResultInput) => ({
    ...input,
  }),
  evictFields: [
    'risk_uncontrolled_internal_audit_result',
    'internal_audit_report',
    'risk_uncontrolled_internal_audit_result_aggregate',
  ],
});
